import {Button, Card, Image} from 'antd';
import {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import {itoh} from 'src/utils';
import styles from './Art.module.scss';

export enum ArtSize {
  Small,
}

type ArtProps = {
  id?: string;
  title?: string | null;
  imageUri?: string | null;
  realArtist?: string | null;
  mintedAt?: string;
  size?: ArtSize;
  selected?: boolean;
  children?: ReactNode;
};

export default function Art(props: ArtProps) {
  return (
    <div className={props.selected ? styles.selected : ''}>
      <Card
        size='small'
        cover={
          <Image
            placeholder
            fallback={process.env.PUBLIC_URL + '/missing.jpg'}
            alt={props.title || 'art'}
            src={itoh(props.imageUri)}
          />
        }>
        {props.size === ArtSize.Small ? (
          props.realArtist || 'Hybrid'
        ) : (
          <>
            <Card.Meta
              title={
                <Link className='plainLink' to={`/arts/${props.id}`}>
                  {props.title}
                </Link>
              }
              description={props.realArtist}
            />
            <div className={styles.right}>
              {props.id && (
                <Link to={`/hybrids/${props.id}/create`}>
                  <Button type='default' size='small' className={styles.createHybrid}>
                    Create Hybrid
                  </Button>
                </Link>
              )}
            </div>
          </>
        )}
        {props.children}
      </Card>
    </div>
  );
}
